import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const coinGecko = defineConnector({
  identifier: "coinGecko",
  name: "CoinGecko",
  tagLine: "Cryptocurrency market data",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: ({ plan }) =>
    plan === "pro"
      ? "https://pro-api\\.coingecko\\.com/.*"
      : "https://api\\.coingecko\\.com/.*",
  auth: (app) =>
    app.configuration.plan === "pro"
      ? headerAuth([{ name: "x-cg-pro-api-key", value: app.secret.apiKey }])
      : headerAuth([{ name: "x-cg-demo-api-key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Create an API key",
      items: [
        {
          kind: "markdown",
          content:
            "In the [CoinGecko developer dashboard](https://www.coingecko.com/en/developers/dashboard), create a demo (free) or pro key.",
        },
      ],
    },
    {
      title: "Enter your CoinGecko details",
      items: [
        {
          kind: "select",
          label: "Plan",
          options: [
            { value: "demo", label: "Demo (free)" },
            { value: "pro", label: "Pro" },
          ],
          defaultValue: "demo",
          required: true,
          target: { kind: "configuration", field: "plan" },
        },
        {
          kind: "input",
          label: "API key",
          placeholder: "CG-...",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ plan }) =>
      plan === "pro"
        ? "https://pro-api.coingecko.com/api/v3/ping"
        : "https://api.coingecko.com/api/v3/ping",
  },
});
